import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSearch = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M21.2856 21.2857L16.2856 16.2857",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M10.5715 18.4286C14.9109 18.4286 18.4286 14.9108 18.4286 10.5714C18.4286 6.23206 14.9109 2.71429 10.5715 2.71429C6.23212 2.71429 2.71436 6.23206 2.71436 10.5714C2.71436 14.9108 6.23212 18.4286 10.5715 18.4286Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgSearch;
